import { Tooltip } from '@material-ui/core';
import MyIcon from 'components/Icon';
import { MyTablePagination, MyTableHeader } from 'components/MyTable';
import Truncate from 'components/Truncate';
import moment from 'moment';
import React from 'react';
import { FormattedNumber } from 'react-intl';
import { useObservable } from 'react-use-observable';
import MyTable from 'v2/components/Shared/MyTable';
import MyTableBody from 'v2/components/Shared/MyTable/MyTableBody';
import MyTableCol from 'v2/components/Shared/MyTable/MyTableCol';
import MyTableEmpty from 'v2/components/Shared/MyTable/MyTableEmpty';
import MyTableLoading from 'v2/components/Shared/MyTable/MyTableLoading';
import MyTableRow from 'v2/components/Shared/MyTable/MyTableRow';
import shoppingService from 'v2/services/shopping/subscription';
import tableService from 'v2/services/table';

import type { IShoppingSubscription } from 'v2/interfaces/shopping';

import useStyle from '../styles';

const headers = [
  { title: '', ordering: false },
  { title: 'Contrato', ordering: false },
  { title: 'Início', ordering: false },
  { title: 'Produto', ordering: false },
  { title: 'Cobrança', ordering: false },
  { title: 'Próx. Vencimento', ordering: false },
  { title: 'Valor', ordering: false },
  { title: '', ordering: false },
];

const SubscriptionList = ({ onClickRow }: { onClickRow: (shopping: IShoppingSubscription) => void }) => {
  const classes = useStyle();
  const [isLoading] = useObservable(() => tableService.isLoading(), []);

  const [list] = useObservable(() => {
    return shoppingService.list();
  }, []);

  const [pagination] = useObservable(() => {
    return shoppingService.getPaginationResponse();
  }, []);

  const onChangeRowsPerPage = (e: React.ChangeEvent<HTMLInputElement>) => {
    const per_page = Number(e.target.value);
    shoppingService.setPagination({ ...pagination, ...{ per_page, current_page: 1 } });
  };

  const onChangePage = (_: unknown, page: number) => {
    const current_page = page + 1;
    shoppingService.setPagination({ ...pagination, ...{ current_page } });
  };
  return (
    <>
      <MyTable responsive>
        <MyTableHeader index={headers} />
        <MyTableLoading colSpan={headers.length} />
        <MyTableBody>
          <MyTableEmpty data={list} colSpan={headers.length} />
          {!isLoading &&
            Array.isArray(list) &&
            list.map((subscription: IShoppingSubscription, index: number) => {
              return (
                <MyTableRow key={`shopping-${index}`}>
                  <MyTableCol screenSizes={{ xs: 2, sm: 2 }}>
                    <Tooltip title={subscription.payment_status.name} placement='top'>
                      <div className={`${classes.tableStatus} --${subscription.payment_status.id}`} />
                    </Tooltip>
                  </MyTableCol>

                  <MyTableCol screenSizes={{ xs: 5, sm: 4 }}>{subscription.id}</MyTableCol>

                  <MyTableCol screenSizes={{ xs: 5, sm: 6 }}>
                    {subscription.initial_date ? moment(subscription.initial_date).format('DD/MM/YYYY') : '-'}
                  </MyTableCol>

                  <MyTableCol screenSizes={{ xs: 12, sm: 12 }}>
                    <div className={classes.product}>
                      <Truncate final='...' count={25}>
                        {subscription.product.title}
                      </Truncate>
                      <span>({subscription.product.id})</span>
                    </div>
                  </MyTableCol>

                  <MyTableCol screenSizes={{ xs: 3, sm: 2 }}>
                    {subscription.payment_charges} /{subscription.cycles && parseInt(subscription.cycles) > 0 ? ' ' + subscription.cycles : ' ∞ '}
                  </MyTableCol>

                  <MyTableCol screenSizes={{ xs: 5, sm: 3 }}>
                    {subscription.next_charge_date && subscription.next_charge_date !== '-'
                      ? moment(subscription.next_charge_date).format('DD/MM/YYYY')
                      : '-'}
                  </MyTableCol>

                  <MyTableCol screenSizes={{ xs: 4, sm: 7 }}>
                    <FormattedNumber value={subscription.total_price} format='BRL' />
                  </MyTableCol>

                  <MyTableCol screenSizes={{ xs: 12, sm: 12 }} action>
                    <div className={classes.options}>
                      <MyIcon name='icon-product-options' onClick={() => onClickRow(subscription)} />
                    </div>
                  </MyTableCol>
                </MyTableRow>
              );
            })}
        </MyTableBody>
      </MyTable>

      {!isLoading && pagination && (
        <MyTablePagination
          onPageChange={onChangePage}
          rowsPerPage={pagination?.per_page || 0}
          count={pagination?.total_items || 0}
          page={pagination?.current_page - 1 || 0}
          labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
          labelRowsPerPage='Itens por página:'
          onChangeRowsPerPage={onChangeRowsPerPage}
          rowsPerPageOptions={[10, 20, 50, 100]}
        />
      )}
    </>
  );
};

export default SubscriptionList;
